import Modal from './Modal'

export default Modal
export { default as useModal } from './useModal'
